forms-schedules-create
  form.form(action="{ opts.action }" method="{ opts.method }" onSubmit="{ this.onSubmit }")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.method")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.authenticity_token")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.line_id")
    inputs-complex-select-phase(tag-scope="{ this.tagScope }.inputs.phase_id")
    inputs-hidden(tag-scope="{ this.tagScope }.inputs.daterange")
    inputs-submit(tag-scope="{ this.tagScope }.inputs.submit" if="{!opts.dataDialog}")
  script(type="typescript").
    this.mixin('forms.schedules.create');
